import SVGAboutButcher from 'themesvg/about-butcher.svg?inline';
import SVGAboutKitchenrepublic from 'themesvg/about-kitchenrepublic.svg?inline';
import SVGAboutMissmiu from 'themesvg/about-missmiu.svg?inline';
import SVGAboutNegishi from 'themesvg/about-negishi.svg?inline';
import SVGAboutNooch from 'themesvg/about-nooch.svg?inline';
import SVGAllergensAllergenalmonds from 'themesvg/allergens-allergenalmonds.svg?inline';
import SVGAllergensAllergenbarley from 'themesvg/allergens-allergenbarley.svg?inline';
import SVGAllergensAllergencashews from 'themesvg/allergens-allergencashews.svg?inline';
import SVGAllergensAllergencelery from 'themesvg/allergens-allergencelery.svg?inline';
import SVGAllergensAllergencrustacean from 'themesvg/allergens-allergencrustacean.svg?inline';
import SVGAllergensAllergeneggs from 'themesvg/allergens-allergeneggs.svg?inline';
import SVGAllergensAllergenfish from 'themesvg/allergens-allergenfish.svg?inline';
import SVGAllergensAllergengluten from 'themesvg/allergens-allergengluten.svg?inline';
import SVGAllergensAllergenlactose from 'themesvg/allergens-allergenlactose.svg?inline';
import SVGAllergensAllergenlupin from 'themesvg/allergens-allergenlupin.svg?inline';
import SVGAllergensAllergenmilk from 'themesvg/allergens-allergenmilk.svg?inline';
import SVGAllergensAllergenmolluscs from 'themesvg/allergens-allergenmolluscs.svg?inline';
import SVGAllergensAllergenmustard from 'themesvg/allergens-allergenmustard.svg?inline';
import SVGAllergensAllergenpeanuts from 'themesvg/allergens-allergenpeanuts.svg?inline';
import SVGAllergensAllergensesameseeds from 'themesvg/allergens-allergensesameseeds.svg?inline';
import SVGAllergensAllergensoy from 'themesvg/allergens-allergensoy.svg?inline';
import SVGAllergensAllergensulphites from 'themesvg/allergens-allergensulphites.svg?inline';
import SVGAllergensAllergentreenuts from 'themesvg/allergens-allergentreenuts.svg?inline';
import SVGAllergensAllergenwheat from 'themesvg/allergens-allergenwheat.svg?inline';
import SVGAverage from 'themesvg/average.svg?inline';
import SVGBag from 'themesvg/bag.svg?inline';
import SVGBigCircleChevronDown from 'themesvg/big-circle-chevron-down.svg?inline';
import SVGCash from 'themesvg/cash.svg?inline';
import SVGCashlessPayment from 'themesvg/cashless-payment.svg?inline';
import SVGCategoryAllButcher from 'themesvg/category-all-butcher.svg?inline';
import SVGCategoryAllNegishi from 'themesvg/category-all-negishi.svg?inline';
import SVGCategoryAll from 'themesvg/category-all.svg?inline';
import SVGCategoryAngrychicken from 'themesvg/category-angrychicken.svg?inline';
import SVGCategoryBeer from 'themesvg/category-beer.svg?inline';
import SVGCategoryBurgersDouble from 'themesvg/category-burgers-double.svg?inline';
import SVGCategoryBurgersSaucy from 'themesvg/category-burgers-saucy.svg?inline';
import SVGCategoryBurgers from 'themesvg/category-burgers.svg?inline';
import SVGCategoryButcher from 'themesvg/category-butcher.svg?inline';
import SVGCategoryChicken from 'themesvg/category-chicken.svg?inline';
import SVGCategoryCocktailLong from 'themesvg/category-cocktail-long.svg?inline';
import SVGCategoryCocktailMedium from 'themesvg/category-cocktail-medium.svg?inline';
import SVGCategoryCocktailShort from 'themesvg/category-cocktail-short.svg?inline';
import SVGCategoryCoffee from 'themesvg/category-coffee.svg?inline';
import SVGCategoryComboButcher from 'themesvg/category-combo-butcher.svg?inline';
import SVGCategoryComboNegishi from 'themesvg/category-combo-negishi.svg?inline';
import SVGCategoryComboNooch from 'themesvg/category-combo-nooch.svg?inline';
import SVGCategoryComboPoke from 'themesvg/category-combo-poke.svg?inline';
import SVGCategoryCurries from 'themesvg/category-curries.svg?inline';
import SVGCategoryDessert from 'themesvg/category-dessert.svg?inline';
import SVGCategoryDrinks from 'themesvg/category-drinks.svg?inline';
import SVGCategoryDumplingbrothers from 'themesvg/category-dumplingbrothers.svg?inline';
import SVGCategoryDumplings from 'themesvg/category-dumplings.svg?inline';
import SVGCategoryExtras from 'themesvg/category-extras.svg?inline';
import SVGCategoryFavorites from 'themesvg/category-favorites.svg?inline';
import SVGCategoryFries from 'themesvg/category-fries.svg?inline';
import SVGCategoryHouseCraftDrink from 'themesvg/category-house-craft-drink.svg?inline';
import SVGCategoryKoreanFavorites from 'themesvg/category-korean-favorites.svg?inline';
import SVGCategoryLolaskitchen from 'themesvg/category-lolaskitchen.svg?inline';
import SVGCategoryLunchNegishi from 'themesvg/category-lunch-negishi.svg?inline';
import SVGCategoryLunchNooch from 'themesvg/category-lunch-nooch.svg?inline';
import SVGCategoryMissmiu from 'themesvg/category-missmiu.svg?inline';
import SVGCategoryNegishi from 'themesvg/category-negishi.svg?inline';
import SVGCategoryNooch from 'themesvg/category-nooch.svg?inline';
import SVGCategoryOutbacklodge from 'themesvg/category-outbacklodge.svg?inline';
import SVGCategoryPokeBowls from 'themesvg/category-poke-bowls.svg?inline';
import SVGCategoryPokenation from 'themesvg/category-pokenation.svg?inline';
import SVGCategoryRiceDish from 'themesvg/category-rice-dish.svg?inline';
import SVGCategorySalads from 'themesvg/category-salads.svg?inline';
import SVGCategorySauce from 'themesvg/category-sauce.svg?inline';
import SVGCategorySlides from 'themesvg/category-slides.svg?inline';
import SVGCategorySoupNoodles from 'themesvg/category-soup-noodles.svg?inline';
import SVGCategorySoup from 'themesvg/category-soup.svg?inline';
import SVGCategorySpecial from 'themesvg/category-special.svg?inline';
import SVGCategorySpeed from 'themesvg/category-speed.svg?inline';
import SVGCategoryStarters from 'themesvg/category-starters.svg?inline';
import SVGCategorySushiPlates from 'themesvg/category-sushi-plates.svg?inline';
import SVGCategorySushi from 'themesvg/category-sushi.svg?inline';
import SVGCategoryTea from 'themesvg/category-tea.svg?inline';
import SVGCategoryVegan from 'themesvg/category-vegan.svg?inline';
import SVGCategoryVegi from 'themesvg/category-vegi.svg?inline';
import SVGCategoryWine from 'themesvg/category-wine.svg?inline';
import SVGChat from 'themesvg/chat.svg?inline';
import SVGCheckmark from 'themesvg/checkmark.svg?inline';
import SVGCircleChevronDown from 'themesvg/circle-chevron-down.svg?inline';
import SVGCircleChevronLeft from 'themesvg/circle-chevron-left.svg?inline';
import SVGCircleChevronRight from 'themesvg/circle-chevron-right.svg?inline';
import SVGCircleChevronUp from 'themesvg/circle-chevron-up.svg?inline';
import SVGCircleMinus from 'themesvg/circle-minus.svg?inline';
import SVGCirclePlay from 'themesvg/circle-play.svg?inline';
import SVGCirclePlus from 'themesvg/circle-plus.svg?inline';
import SVGClimateNeutral from 'themesvg/climate-neutral.svg?inline';
import SVGClock from 'themesvg/clock.svg?inline';
import SVGClose from 'themesvg/close.svg?inline';
import SVGCookieSmall from 'themesvg/cookie-small.svg?inline';
import SVGCookie from 'themesvg/cookie.svg?inline';
import SVGCreditCard from 'themesvg/credit-card.svg?inline';
import SVGCross from 'themesvg/cross.svg?inline';
import SVGDatatrans from 'themesvg/datatrans.svg?inline';
import SVGDate from 'themesvg/date.svg?inline';
import SVGDelivery from 'themesvg/delivery.svg?inline';
import SVGDeliveryman from 'themesvg/deliveryman.svg?inline';
import SVGDishBowl from 'themesvg/dish-bowl.svg?inline';
import SVGDuplicate from 'themesvg/duplicate.svg?inline';
import SVGEdit from 'themesvg/edit.svg?inline';
import SVGEnvelope from 'themesvg/envelope.svg?inline';
import SVGFacebookNoBorder from 'themesvg/facebook-no-border.svg?inline';
import SVGFacebook from 'themesvg/facebook.svg?inline';
import SVGFilterDessert from 'themesvg/filter-dessert.svg?inline';
import SVGFilterVegan from 'themesvg/filter-vegan.svg?inline';
import SVGFilterVegi from 'themesvg/filter-vegi.svg?inline';
import SVGFilter from 'themesvg/filter.svg?inline';
import SVGGeoLocation from 'themesvg/geo-location.svg?inline';
import SVGIndiningMenu from 'themesvg/indining-menu.svg?inline';
import SVGIndining from 'themesvg/indining.svg?inline';
import SVGInfo from 'themesvg/info.svg?inline';
import SVGInsta from 'themesvg/insta.svg?inline';
import SVGInstagram from 'themesvg/instagram.svg?inline';
import SVGLinkedin from 'themesvg/linkedin.svg?inline';
import SVGLocation from 'themesvg/location.svg?inline';
import SVGLogoButcher from 'themesvg/logo-butcher.svg?inline';
import SVGLogoFwgch from 'themesvg/logo-fwgch.svg?inline';
import SVGLogoKitchenrepublic from 'themesvg/logo-kitchenrepublic.svg?inline';
import SVGLogoMissmiu from 'themesvg/logo-missmiu.svg?inline';
import SVGLogoNegishi from 'themesvg/logo-negishi.svg?inline';
import SVGLogoNooch from 'themesvg/logo-nooch.svg?inline';
import SVGLogoOutbacklodge from 'themesvg/logo-outbacklodge.svg?inline';
import SVGLogoRewardz from 'themesvg/logo-rewardz.svg?inline';
import SVGLogoSimpleButcher from 'themesvg/logo-simple-butcher.svg?inline';
import SVGLogoSimpleFwgch from 'themesvg/logo-simple-fwgch.svg?inline';
import SVGLogoSimpleKitchenrepublic from 'themesvg/logo-simple-kitchenrepublic.svg?inline';
import SVGLogoSimpleMissmiu from 'themesvg/logo-simple-missmiu.svg?inline';
import SVGLogoSimpleNegishi from 'themesvg/logo-simple-negishi.svg?inline';
import SVGLogoSimpleNooch from 'themesvg/logo-simple-nooch.svg?inline';
import SVGLogoSimpleOutbacklodge from 'themesvg/logo-simple-outbacklodge.svg?inline';
import SVGLogoSimpleRewardz from 'themesvg/logo-simple-rewardz.svg?inline';
import SVGMap from 'themesvg/map.svg?inline';
import SVGMenuAllergens from 'themesvg/menu-allergens.svg?inline';
import SVGMenuDrinks from 'themesvg/menu-drinks.svg?inline';
import SVGMenuInformation from 'themesvg/menu-information.svg?inline';
import SVGMenuKids from 'themesvg/menu-kids.svg?inline';
import SVGMenuLunch from 'themesvg/menu-lunch.svg?inline';
import SVGMenuSushi from 'themesvg/menu-sushi.svg?inline';
import SVGMenu from 'themesvg/menu.svg?inline';
import SVGMidCircleChevronDown from 'themesvg/mid-circle-chevron-down.svg?inline';
import SVGMidCircleChevronLeft from 'themesvg/mid-circle-chevron-left.svg?inline';
import SVGMidCircleChevronRight from 'themesvg/mid-circle-chevron-right.svg?inline';
import SVGMidCircleChevronUp from 'themesvg/mid-circle-chevron-up.svg?inline';
import SVGMinus from 'themesvg/minus.svg?inline';
import SVGMoney from 'themesvg/money.svg?inline';
import SVGNote from 'themesvg/note.svg?inline';
import SVGPaymentApplePay from 'themesvg/payment-apple-pay.svg?inline';
import SVGPaymentDinersClub from 'themesvg/payment-diners-club.svg?inline';
import SVGPaymentDiscover from 'themesvg/payment-discover.svg?inline';
import SVGPaymentFwgGiftCard from 'themesvg/payment-fwg-gift-card.svg?inline';
import SVGPaymentGooglePay from 'themesvg/payment-google-pay.svg?inline';
import SVGPaymentIconNoCash from 'themesvg/payment-icon-no-cash.svg?inline';
import SVGPaymentIcons from 'themesvg/payment-icons.svg?inline';
import SVGPaymentJcb from 'themesvg/payment-jcb.svg?inline';
import SVGPaymentLunchCheck from 'themesvg/payment-lunch-check.svg?inline';
import SVGPaymentMaestro from 'themesvg/payment-maestro.svg?inline';
import SVGPaymentMastercard from 'themesvg/payment-mastercard.svg?inline';
import SVGPaymentPostfinance from 'themesvg/payment-postfinance.svg?inline';
import SVGPaymentSamsungPay from 'themesvg/payment-samsung-pay.svg?inline';
import SVGPaymentSamsungWallet from 'themesvg/payment-samsung-wallet.svg?inline';
import SVGPaymentTwint from 'themesvg/payment-twint.svg?inline';
import SVGPaymentVisa from 'themesvg/payment-visa.svg?inline';
import SVGPhone from 'themesvg/phone.svg?inline';
import SVGPinterest from 'themesvg/pinterest.svg?inline';
import SVGPlateCutlery from 'themesvg/plate-cutlery.svg?inline';
import SVGPlay from 'themesvg/play.svg?inline';
import SVGPlus from 'themesvg/plus.svg?inline';
import SVGQrCode from 'themesvg/qr-code.svg?inline';
import SVGReserve from 'themesvg/reserve.svg?inline';
import SVGReset from 'themesvg/reset.svg?inline';
import SVGSauce from 'themesvg/sauce.svg?inline';
import SVGScanIllustrationPhone from 'themesvg/scan-illustration-phone.svg?inline';
import SVGSettings from 'themesvg/settings.svg?inline';
import SVGSmallAverage from 'themesvg/small-average.svg?inline';
import SVGSmallCheckmark from 'themesvg/small-checkmark.svg?inline';
import SVGSmallChevronDown from 'themesvg/small-chevron-down.svg?inline';
import SVGSmallChevronUp from 'themesvg/small-chevron-up.svg?inline';
import SVGSmallCircleFull from 'themesvg/small-circle-full.svg?inline';
import SVGSmallCircle from 'themesvg/small-circle.svg?inline';
import SVGSmallClose from 'themesvg/small-close.svg?inline';
import SVGSmallCross from 'themesvg/small-cross.svg?inline';
import SVGSpeechBubble from 'themesvg/speech-bubble.svg?inline';
import SVGSpice from 'themesvg/spice.svg?inline';
import SVGSpotify from 'themesvg/spotify.svg?inline';
import SVGStarFilledHalf from 'themesvg/star-filled-half.svg?inline';
import SVGStarFilled from 'themesvg/star-filled.svg?inline';
import SVGStarHalf from 'themesvg/star-half.svg?inline';
import SVGStar from 'themesvg/star.svg?inline';
import SVGSticksAngled from 'themesvg/sticks-angled.svg?inline';
import SVGSticks from 'themesvg/sticks.svg?inline';
import SVGStore from 'themesvg/store.svg?inline';
import SVGTakeaway from 'themesvg/takeaway.svg?inline';
import SVGTiktok from 'themesvg/tiktok.svg?inline';
import SVGTrash from 'themesvg/trash.svg?inline';
import SVGTwitter from 'themesvg/twitter.svg?inline';
import SVGUberDirect from 'themesvg/uber-direct.svg?inline';
import SVGUserSmall from 'themesvg/user-small.svg?inline';
import SVGUser from 'themesvg/user.svg?inline';
import SVGUsers from 'themesvg/users.svg?inline';
import SVGWarning from 'themesvg/warning.svg?inline';
import SVGWhatsapp from 'themesvg/whatsapp.svg?inline';
import SVGXing from 'themesvg/xing.svg?inline';
import SVGYoutube from 'themesvg/youtube.svg?inline';

export default {
	SVGAboutButcher,
	SVGAboutKitchenrepublic,
	SVGAboutMissmiu,
	SVGAboutNegishi,
	SVGAboutNooch,
	SVGAllergensAllergenalmonds,
	SVGAllergensAllergenbarley,
	SVGAllergensAllergencashews,
	SVGAllergensAllergencelery,
	SVGAllergensAllergencrustacean,
	SVGAllergensAllergeneggs,
	SVGAllergensAllergenfish,
	SVGAllergensAllergengluten,
	SVGAllergensAllergenlactose,
	SVGAllergensAllergenlupin,
	SVGAllergensAllergenmilk,
	SVGAllergensAllergenmolluscs,
	SVGAllergensAllergenmustard,
	SVGAllergensAllergenpeanuts,
	SVGAllergensAllergensesameseeds,
	SVGAllergensAllergensoy,
	SVGAllergensAllergensulphites,
	SVGAllergensAllergentreenuts,
	SVGAllergensAllergenwheat,
	SVGAverage,
	SVGBag,
	SVGBigCircleChevronDown,
	SVGCash,
	SVGCashlessPayment,
	SVGCategoryAllButcher,
	SVGCategoryAllNegishi,
	SVGCategoryAll,
	SVGCategoryAngrychicken,
	SVGCategoryBeer,
	SVGCategoryBurgersDouble,
	SVGCategoryBurgersSaucy,
	SVGCategoryBurgers,
	SVGCategoryButcher,
	SVGCategoryChicken,
	SVGCategoryCocktailLong,
	SVGCategoryCocktailMedium,
	SVGCategoryCocktailShort,
	SVGCategoryCoffee,
	SVGCategoryComboButcher,
	SVGCategoryComboNegishi,
	SVGCategoryComboNooch,
	SVGCategoryComboPoke,
	SVGCategoryCurries,
	SVGCategoryDessert,
	SVGCategoryDrinks,
	SVGCategoryDumplingbrothers,
	SVGCategoryDumplings,
	SVGCategoryExtras,
	SVGCategoryFavorites,
	SVGCategoryFries,
	SVGCategoryHouseCraftDrink,
	SVGCategoryKoreanFavorites,
	SVGCategoryLolaskitchen,
	SVGCategoryLunchNegishi,
	SVGCategoryLunchNooch,
	SVGCategoryMissmiu,
	SVGCategoryNegishi,
	SVGCategoryNooch,
	SVGCategoryOutbacklodge,
	SVGCategoryPokeBowls,
	SVGCategoryPokenation,
	SVGCategoryRiceDish,
	SVGCategorySalads,
	SVGCategorySauce,
	SVGCategorySlides,
	SVGCategorySoupNoodles,
	SVGCategorySoup,
	SVGCategorySpecial,
	SVGCategorySpeed,
	SVGCategoryStarters,
	SVGCategorySushiPlates,
	SVGCategorySushi,
	SVGCategoryTea,
	SVGCategoryVegan,
	SVGCategoryVegi,
	SVGCategoryWine,
	SVGChat,
	SVGCheckmark,
	SVGCircleChevronDown,
	SVGCircleChevronLeft,
	SVGCircleChevronRight,
	SVGCircleChevronUp,
	SVGCircleMinus,
	SVGCirclePlay,
	SVGCirclePlus,
	SVGClimateNeutral,
	SVGClock,
	SVGClose,
	SVGCookieSmall,
	SVGCookie,
	SVGCreditCard,
	SVGCross,
	SVGDatatrans,
	SVGDate,
	SVGDelivery,
	SVGDeliveryman,
	SVGDishBowl,
	SVGDuplicate,
	SVGEdit,
	SVGEnvelope,
	SVGFacebookNoBorder,
	SVGFacebook,
	SVGFilterDessert,
	SVGFilterVegan,
	SVGFilterVegi,
	SVGFilter,
	SVGGeoLocation,
	SVGIndiningMenu,
	SVGIndining,
	SVGInfo,
	SVGInsta,
	SVGInstagram,
	SVGLinkedin,
	SVGLocation,
	SVGLogoButcher,
	SVGLogoFwgch,
	SVGLogoKitchenrepublic,
	SVGLogoMissmiu,
	SVGLogoNegishi,
	SVGLogoNooch,
	SVGLogoOutbacklodge,
	SVGLogoRewardz,
	SVGLogoSimpleButcher,
	SVGLogoSimpleFwgch,
	SVGLogoSimpleKitchenrepublic,
	SVGLogoSimpleMissmiu,
	SVGLogoSimpleNegishi,
	SVGLogoSimpleNooch,
	SVGLogoSimpleOutbacklodge,
	SVGLogoSimpleRewardz,
	SVGMap,
	SVGMenuAllergens,
	SVGMenuDrinks,
	SVGMenuInformation,
	SVGMenuKids,
	SVGMenuLunch,
	SVGMenuSushi,
	SVGMenu,
	SVGMidCircleChevronDown,
	SVGMidCircleChevronLeft,
	SVGMidCircleChevronRight,
	SVGMidCircleChevronUp,
	SVGMinus,
	SVGMoney,
	SVGNote,
	SVGPaymentApplePay,
	SVGPaymentDinersClub,
	SVGPaymentDiscover,
	SVGPaymentFwgGiftCard,
	SVGPaymentGooglePay,
	SVGPaymentIconNoCash,
	SVGPaymentIcons,
	SVGPaymentJcb,
	SVGPaymentLunchCheck,
	SVGPaymentMaestro,
	SVGPaymentMastercard,
	SVGPaymentPostfinance,
	SVGPaymentSamsungPay,
	SVGPaymentSamsungWallet,
	SVGPaymentTwint,
	SVGPaymentVisa,
	SVGPhone,
	SVGPinterest,
	SVGPlateCutlery,
	SVGPlay,
	SVGPlus,
	SVGQrCode,
	SVGReserve,
	SVGReset,
	SVGSauce,
	SVGScanIllustrationPhone,
	SVGSettings,
	SVGSmallAverage,
	SVGSmallCheckmark,
	SVGSmallChevronDown,
	SVGSmallChevronUp,
	SVGSmallCircleFull,
	SVGSmallCircle,
	SVGSmallClose,
	SVGSmallCross,
	SVGSpeechBubble,
	SVGSpice,
	SVGSpotify,
	SVGStarFilledHalf,
	SVGStarFilled,
	SVGStarHalf,
	SVGStar,
	SVGSticksAngled,
	SVGSticks,
	SVGStore,
	SVGTakeaway,
	SVGTiktok,
	SVGTrash,
	SVGTwitter,
	SVGUberDirect,
	SVGUserSmall,
	SVGUser,
	SVGUsers,
	SVGWarning,
	SVGWhatsapp,
	SVGXing,
	SVGYoutube
}